module.exports = __webpack_public_path__ + "img/SmartRemote_mehrfarbig_RGB.57294dd9.svg";